import { useEffect, useState } from "react";

import styles from "./index.module.css";
import { useCategory } from "../../hooks/useCategory";
import { CategoryType } from "../../contexts/CategoryContext";
import { Loading } from "../../components/Loading";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";

import { useNavigate, useParams } from "react-router-dom";
import EmptyState from "../../components/EmptyStates/EmptyState";
import { CategoryItemAtacado } from "../../components/CatalogItem";
import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import { HeaderMultCategories } from "../../components/HeaderMultCategories";
import { HeaderCategories } from "../../components/HeaderCategories";

export function CategoriesList() {
  const { getAppConfig, saveBlockLayout, blockLayout } = useAppConfig();
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  // Array de categorias com 15 itens
  const [categorias, setCategorias] = useState<
    { id: string; nome: string; imagem: string }[]
  >([]);
  const { getCategoriesAll } = useCategory();
  const [isLoading, setIsLoading] = useState(false);
  const [config, setConfig] = useState<ConfigType | void>();
  const [showClassificationName, setShowClassificationName] = useState(true);
  const [loadingHeader, setLoadingHeader] = useState(false);
  const [showBlockView, setShowBlockView] = useState(false);

  const [useShadow, setUseShadow] = useState(true);

  async function getCategorias() {
    try {
      const response = await getCategoriesAll();

      setCategorias(
        response.map((item: CategoryType) => {
          return {
            id: item.id.toString(),
            nome: item.name,
            imagem:
              item.img || "https://via.placeholder.com/500x500?text=Sem+Imagem",
          };
        })
      );

      return response;
    } catch (error) {
      return {
        success: false,
        data: [],
      };
    }
  }

  async function getConfig() {
    const _config = await getAppConfig();

    if (_config) {
      setShowClassificationName(_config.content.showClassificationName);
      setShowBlockView(!_config?.content.useCategoryList);
      setUseShadow(!_config.content.removeShadow);
    }

    setConfig(_config);
  }

  async function loadAll() {
    setIsLoading(true);
    await getConfig();
    await getCategorias();
    setIsLoading(false);
  }

  useEffect(() => {
    loadAll();
  }, []);

  // return (
  //     <div className={styles.category_page}>
  //         {isLoading ? (
  //             <div className={styles.container_loading}>
  //                 <Loading
  //                     type="spinningBubbles"
  //                     color="#FFF"
  //                     width={64}
  //                     height={64}
  //                 />
  //             </div>
  //         ) : (
  //             <>
  //                 <Header
  //                     background={config?.webappcolor.backgroundheader ? config?.webappcolor.backgroundheader : '#F5F5F5'}
  //                     colorIcon={config?.webappcolor.iconsheader ? config.webappcolor.iconsheader : "#636363"}
  //                     logo={config?.icon ? config.icon : ''}
  //                     backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
  //                     fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
  //                     noSales={
  //                         (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
  //                             ? config.content.pdv.noSales
  //                             : false
  //                     }
  //                 />

  //                 {categorias.length === 0 ? (<>
  //                     <div className={styles.emptyState}>
  //                         <EmptyState
  //                         type={"category"} textButton={"Voltar"}
  //                         noShowBackground
  //                         colorIcon={config?.webappcolor.iconsheader
  //                             ? config.webappcolor.iconsheader
  //                             : "#CEA127"}

  //                         action={()=> navigate(-1)}
  //                             />
  //                     </div>
  //                 </>) : (
  //                     <>

  //                         <div className={styles.category_container}>
  //                             <HeaderCategories
  //                                 fontColor={
  //                                     config?.webappcolor.fonttitlebar
  //                                         ? config.webappcolor.fonttitlebar
  //                                         : "#FFFFFF"
  //                                 }
  //                                 backgroundColor={
  //                                     config?.webappcolor.backgroundtitlebar
  //                                         ? config.webappcolor.backgroundtitlebar
  //                                         : "#000000"
  //                                 }
  //                                 categories={["Categorias"]}
  //                                 blockViewMode={
  //                                     config && config.content.noUseViewMode
  //                                         ? config.content.noUseViewMode
  //                                         : false
  //                                 }
  //                                 inBlocks={blockLayout}
  //                                 setInBlocks={saveBlockLayout}
  //                             />

  //                             <div className={styles.category_container_header}>
  //                                 <span className={styles.title_container}> CATEGORIAS</span>
  //                             </div>
  //                             <div className={styles.container_categories}>
  //                                 <div className={`${!blockLayout ? `${styles.grid_1_col} animate__animated  animate__fadeIn ` : `${styles.grid_2_col}  animate__animated animate__fadeIn `}`}
  //                                     style={{ animationDelay: `400ms` }}
  //                                 >
  //                                     {categorias.map((categoria: any) => (
  //                                         <CategoryItemAtacado animationDelay={200} category={categoria} legendColor={""} noShadow={useShadow} showName={showClassificationName} />
  //                                     ))}
  //                                 </div>
  //                             </div>
  //                         </div>

  //                     </>
  //                 )}

  //                 <Menu
  //                     activeMenu="category"
  //                     fontColor={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
  //                     activeFontColor={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#000'}
  //                     backgroundMenu={config?.webappcolor.backgroundfooter ? config?.webappcolor.backgroundfooter : '#F5F5F5'}
  //                     colorIcons={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
  //                     highlightColorIcons={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#636363'}
  //                     backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
  //                     fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
  //                     noSales={
  //                         (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
  //                             ? config.content.pdv.noSales
  //                             : false
  //                     }
  //                 />
  //             </>

  //         )
  //         }
  //     </div>

  // )
  return (
    <div className="subcategory">
      <div className="content-subcategory">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {isLoading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : categorias.length === 0 ? (
          <div className={styles.emptyState}>
            <EmptyState
              type={"category"}
              textButton={"Voltar"}
              noShowBackground
              colorIcon={
                config?.webappcolor.iconsheader
                  ? config.webappcolor.iconsheader
                  : "#CEA127"
              }
              action={() => navigate(-1)}
            />
          </div>
        ) : (
          <>
            <div className={styles.category_container}>
              <HeaderCategories
                fontColor={
                  config?.webappcolor.fonttitlebar
                    ? config.webappcolor.fonttitlebar
                    : "#FFFFFF"
                }
                backgroundColor={
                  config?.webappcolor.backgroundtitlebar
                    ? config.webappcolor.backgroundtitlebar
                    : "#000000"
                }
                categories={["Categorias"]}
                blockViewMode={
                  config && config.content.noUseViewMode
                    ? config.content.noUseViewMode
                    : false
                }
                inBlocks={blockLayout}
                setInBlocks={saveBlockLayout}
              />

              <div className={styles.container_categories}>
                <div
                  className={`${
                    !blockLayout
                      ? `${styles.grid_1_col} animate__animated  animate__fadeIn `
                      : `${styles["subcategory-items-grid"]} animate__animated animate__fadeIn `
                  } ${styles.container_list_all}`}
                  style={{ animationDelay: `400ms` }}
                >
                  {categorias.map((categoria: any) => (
                    <CategoryItemAtacado
                      animationDelay={200}
                      category={categoria}
                      legendColor={""}
                      noShadow={useShadow}
                      showName={showClassificationName}
                    />
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        <Menu
          activeMenu="category"
          fontColor={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          activeFontColor={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#000"
          }
          backgroundMenu={
            config?.webappcolor.backgroundfooter
              ? config?.webappcolor.backgroundfooter
              : "#F5F5F5"
          }
          colorIcons={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          highlightColorIcons={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#636363"
          }
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      </div>
    </div>
  );
}
